import kgPluginClient from './kgPluginClient.js';
import {
  resolveRedirectOrBinaryMediaUrl,
  buildMediaSourceResult
} from './musicPluginProxy.js';

/**
 * 洛雪音乐「长青SVIP音源」脚本 - 酷狗线路
 * 与现有 kgPluginClient 使用完全不同的解析后端（kgqq1/kg.php + level 参数），
 * 因此作为独立音源呈现，搜索复用官方接口结果，仅播放直链不同。
 */
const PLATFORM = 'lx-kg';
const SOURCE_TAG = 'lx-kg-plugin';

const LEVELS = {
  low: 'standard',
  standard: 'standard',
  high: 'exhigh',
  super: 'lossless'
};

const REQUEST_HEADERS = {
  Referer: 'https://www.kugou.com/',
  'User-Agent':
    'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.0.0 Safari/537.36'
};

async function search(query, page = 1) {
  const result = await kgPluginClient.search(query, page);
  return {
    ...result,
    data: result.data.map((song) => ({ ...song, source: SOURCE_TAG }))
  };
}

async function getMediaSource(musicItem, quality = 'high') {
  const songId = musicItem?.id || musicItem?.raw?.FileHash || musicItem?.raw?.hash;
  if (!songId) {
    throw new Error('酷狗歌曲ID不能为空');
  }

  const level = LEVELS[quality] || LEVELS.high;
  const audioUrl = `https://music.haitangw.cc/kgqq1/kg.php?type=mp3&id=${songId}&level=${level}`;

  try {
    const audioData = await resolveRedirectOrBinaryMediaUrl(audioUrl, REQUEST_HEADERS);
    return buildMediaSourceResult(audioData, musicItem, quality);
  } catch (primaryError) {
    console.warn('[lxKgPluginClient] 长青线路获取失败，回退官方酷狗客户端:', primaryError.message);
    return kgPluginClient.getMediaSource(musicItem, quality);
  }
}

async function getLyric(musicItem, options = {}) {
  if (options.cachedLyric) {
    return options.cachedLyric;
  }

  try {
    const result = await getMediaSource(musicItem, 'high');
    if (result.lyric) {
      return result.lyric;
    }
  } catch (error) {
    console.warn('[lxKgPluginClient] 长青线路获取歌词失败，回退官方酷狗客户端:', error.message);
  }

  return kgPluginClient.getLyric(musicItem, options);
}

const lxKgPluginClient = {
  platform: PLATFORM,
  version: '1.2.0',
  search,
  getMediaSource,
  getLyric
};

export default lxKgPluginClient;
